module.exports = __webpack_public_path__ + "static/img/Test.43c4cc65.jpeg";